import { render, staticRenderFns } from "./DotList.vue?vue&type=template&id=37b5130c&"
import script from "./DotList.vue?vue&type=script&lang=js&"
export * from "./DotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports